





















import SvgImage from '@/app/components/SvgImage.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'Error500',
    metaInfo: {
        title: 'Internal server error',
    },
    components: { SvgImage },
});
